export default function minTranslate() {
  return -this.snapGrid[0];
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/core/translate/minTranslate.js
// module id = 1183
// module chunks = 9